import { useState, useEffect, useRef } from "react";
import "./EditCerificate.scss";
import { TemplateEditor } from "../../components/TemplateEditor/TemplateEditor";
import AuiButton from "../../components/Buttons/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import { getCertificateById } from "../../services/training-session.service";
import { useDispatch } from "react-redux";
import { showAlert } from "../../store/alertSlice";

const EditCerificate = () => {
  const navigate = useNavigate();
  const [editedData, setEditedData] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditorReady, setIsEditorReady] = useState<boolean>(false);
  const [certificateData, setCertificateData] = useState({
    template: "",
    certificateType: "",
    parentId: null,
  });
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const certificateRef = useRef(certificateData);

  useEffect(() => {
    const getCertificateTemplate = async () => {
      try {
        const certificateId = parseInt(id ?? "", 10);
        const result = await getCertificateById(certificateId);
        if (!result || result.status !== 200) {
          dispatch(
            showAlert({
              message: "Failed to fetch certificate template",
              type: "error",
            })
          );
        } else {
          certificateRef.current = {
            template: result?.data?.certificate?.template || "",
            certificateType: result?.data?.certificate?.certificateType || "",
            parentId: result?.data?.certificate?.id || null,
          };
          setCertificateData(certificateRef.current);
        }
      } catch (error) {
        console.error("Error fetching certificate:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getCertificateTemplate();
  }, [id]);

  function handleTemplateChange(html: string) {
    const finalHtml =
      `<!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
      <head>
     <meta charset="UTF-8">
     <style type="text/css">
         @import url("https://cme-dev-apifont.heartblr.org/stylesheet.css");
         @import url("https://fonts.cdnfonts.com/css/times-new-roman");
         @import url("https://fonts.cdnfonts.com/css/arial");
         * {
         box-sizing: border-box;
         }
         body {
         margin: 0;
         font-family: "helvetica neue lt std";
         font-weight: 400;
         line-height: 1.3;
         }
     </style>
     </head>
       <body>` +
      html +
      "</body></html>";
    setEditedData(finalHtml);
  }

  return (
    <div className="template-editor-container">
      <TemplateEditor
        html={certificateData.template}
        onChange={handleTemplateChange}
        onEditorInit={() => setIsEditorReady(true)}
      />

      {(isLoading || !isEditorReady) && (
        <div className="loader-container">
          <aui-loader type="content"></aui-loader>
        </div>
      )}

      <div className="button-container">
        <AuiButton
          variant="primary"
          buttontitle="PDF Preview"
          buttonid="primary-btn"
          size="large"
          buttonclass="actionBtn px-2"
          buttonClick={() =>
            navigate("/preview-pdf", {
              state: {
                certificateData,
                editedData,
              },
            })
          }
        />
      </div>
    </div>
  );
};

export default EditCerificate;
